import styles from "src/components/molecules/User/styles.module.css";
import Avatar from "src/assets/images/listAvatar.svg";
import { useEffect, useRef, useState } from "react";
import ArrowDown from "src/assets/icons/arrowDown.svg";
import ArrowUp from "src/assets/icons/arrowUp.svg";
import { Msg } from "src/i18n/Msg";
import Profile from "src/assets/icons/profile.svg";
import PromoCode from "src/assets/icons/promocode.svg";
import Settings from "src/assets/icons/settings.svg";
import Referal from "src/assets/icons/referal.svg";
import Logout from "src/assets/icons/logout.svg";
import About from "src/assets/icons/about.svg";
import { useRedirect } from "src/navigation/useRedirect";
import { PAGES } from "src/types/navigation";
import { PromoCodeModal } from "src/components/organisms/PromoCodeModal";
import { useUserLogout } from "src/queries/useUserLogout";
import { RootState } from "src/store";
import { useSelector } from "react-redux";
import { debounce } from "lodash";
import { isTelegramWebApp } from "src/utils/telegramWebApp";

type Props = {
  handleCollapseMenu?: () => void;
  openOnboardingModal?: () => void;
};
export const User: React.FC<Props> = ({
  handleCollapseMenu,
  openOnboardingModal,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector((state: RootState) => state.profile.user);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const toggleButtonRef = useRef<HTMLDivElement | null>(null);

  const { redirect } = useRedirect();
  const { logoutMutate } = useUserLogout();
  const isTgVersion = isTelegramWebApp();
  const handleRedirect = (scheme: PAGES) => redirect({ scheme });
  const [openPromoCodeModal, setIsOpenPromoCodeModal] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const debouncedToggle = debounce(handleToggle, 100);

  return (
    <>
      <div
        className={styles.user}
        role="button"
        ref={toggleButtonRef}
        onClick={debouncedToggle}
      >
        <div className={styles.userContent}>
          <div
            className={styles.img}
            onClick={handleCollapseMenu}
            role="button"
          >
            <img src={user?.profile_picture ?? Avatar} alt="avatar" />
          </div>
          <div className={styles.arrow}>
            <img src={isOpen ? ArrowUp : ArrowDown} alt="arroe" />
          </div>
        </div>

        {isOpen && (
          <div className={styles.dropdown} ref={dropdownRef}>
            <div
              className={styles.userName}
              onClick={() => handleRedirect(PAGES.EDIT_PROFILE)}
            >
              <img src={user?.profile_picture ?? Avatar} alt="avatar" />
              <h3>{user?.username ?? ""}</h3>
            </div>
            <div className={styles.list}>
              <div
                className={styles.listItem}
                role="button"
                onClick={() => handleRedirect(PAGES.POSITIONS)}
              >
                <img src={Profile} alt="Profile" />
                <h5>
                  <Msg id="components.molecules.User.profile" />
                </h5>
              </div>
              <div
                className={styles.listItem}
                role="button"
                onClick={() => handleRedirect(PAGES.EDIT_PROFILE)}
              >
                <img src={Settings} alt="Settings" />
                <h5>
                  <Msg id="components.molecules.User.settings" />
                </h5>
              </div>
              <div
                className={styles.listItem}
                role="button"
                onClick={() => setIsOpenPromoCodeModal(true)}
              >
                <img src={PromoCode} alt="PromoCode" />
                <h5>
                  <Msg id="components.molecules.User.promocode" />
                </h5>
              </div>
              <div
                className={styles.listItem}
                role="button"
                onClick={() => handleRedirect(PAGES.REFERALS)}
              >
                <img src={Referal} alt="Referal" />
                <h5>
                  <Msg id="components.molecules.User.referal" />
                </h5>
              </div>
              <div
                className={styles.listItem}
                role="button"
                onClick={() => {
                  setIsOpen(false);
                  openOnboardingModal?.();
                }}
              >
                <img src={About} alt="About stock" />
                <h5>
                  <Msg id="components.molecules.User.about" />
                </h5>
              </div>
            </div>
            {!isTgVersion && (
              <div
                className={styles.logout}
                role="button"
                onClick={() => logoutMutate()}
              >
                <img src={Logout} alt="Logout" />
                <h3>
                  <Msg id="components.molecules.User.logout" />
                </h3>
              </div>
            )}
          </div>
        )}
      </div>
      <PromoCodeModal
        isOpen={openPromoCodeModal}
        close={() => setIsOpenPromoCodeModal(false)}
      />
    </>
  );
};
